var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "v-dialog-fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        staticClass: "v-dialog-box",
      },
      [
        _c("transition", { attrs: { name: "v-dialog-fade" } }, [
          _vm.modal
            ? _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visible,
                    expression: "visible",
                  },
                ],
                staticClass: "v-modal",
                on: { click: _vm.handleClickModal },
              })
            : _vm._e(),
        ]),
        _c("transition", { attrs: { name: "v-dialog-inner-fade" } }, [
          _vm.visible
            ? _c(
                "div",
                {
                  ref: "dialog",
                  staticClass: "v-dialog",
                  style: _vm.dialogStyle,
                },
                [
                  _vm.showTitle
                    ? _c(
                        "div",
                        { ref: "header", staticClass: "v-dialog__header" },
                        [
                          _vm._t("title", function () {
                            return [
                              _c(
                                "div",
                                {
                                  class: [
                                    `v-dialog__title`,
                                    { "v-dialog__close-space": _vm.showClose },
                                  ],
                                },
                                [
                                  _c(
                                    "h5",
                                    {
                                      class: [
                                        "v-dialog__title-inner",
                                        { "v-dialog__center": _vm.alignCenter },
                                      ],
                                    },
                                    [_vm._v(" " + _vm._s(_vm.title) + " ")]
                                  ),
                                ]
                              ),
                            ]
                          }),
                          _vm.showClose
                            ? _c("i", {
                                staticClass: "v-dialog__close v-icon-close",
                                on: { click: _vm.close },
                              })
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      ref: "main",
                      staticClass: "v-dialog__main",
                      style: { "max-height": _vm.mainMaxHeight + "px" },
                    },
                    [_vm._t("default")],
                    2
                  ),
                  _c(
                    "div",
                    {
                      ref: "footer",
                      class: ["v-dialog__footer", _vm.footerClass],
                    },
                    [
                      _vm._t("footer", function () {
                        return [
                          _c(
                            "div",
                            {
                              class: [
                                "v-dialog__button-group",
                                { "v-dialog__center": _vm.alignCenter },
                              ],
                            },
                            [
                              _vm.showCancel
                                ? _c(
                                    "v-button",
                                    {
                                      staticClass: "v-dialog__button-item",
                                      attrs: {
                                        type: _vm.cancelButtonType,
                                        size: "M",
                                      },
                                      on: { click: _vm.handleCancel },
                                    },
                                    [_vm._v(_vm._s(_vm.cancelButtonText))]
                                  )
                                : _vm._e(),
                              _vm.showConfirm
                                ? _c(
                                    "v-button",
                                    {
                                      staticClass: "v-dialog__button-item",
                                      attrs: {
                                        type: _vm.confirmButtonType,
                                        size: "M",
                                      },
                                      on: { click: _vm.handleConfirm },
                                    },
                                    [_vm._v(_vm._s(_vm.confirmButtonText))]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }